var _path, _path2, _path3, _rect, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGasespera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8101 8.62898L14.0018 21.2854C13.9293 21.7934 14.13 22.0524 14.651 22.1268L17.8536 22.5844C18.346 22.6547 18.6224 22.4552 18.6902 21.9803C18.8805 20.6483 20.283 10.832 20.4731 9.50147L20.502 9.29932L15.8101 8.62898Z",
    stroke: "#7341B5",
    strokeWidth: 1.73629
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8829 8.15756L20.5444 8.82356C20.6394 8.15854 20.8001 7.50511 20.8098 6.84787C20.8185 6.00197 20.1508 5.31226 19.3078 5.17408C18.8098 5.09516 18.3061 5.00102 17.8074 5.00517C17.3974 5.0168 17.0048 5.16962 16.6974 5.43726C16.3901 5.70489 16.1872 6.07055 16.1238 6.4711C16.0321 7.02682 15.9645 7.58599 15.8829 8.15756Z",
    stroke: "#7341B5",
    strokeWidth: 1.73629
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3804 4.00801C20.4385 3.6012 20.1558 3.22431 19.749 3.16619L18.6441 3.00833C18.2373 2.95021 17.8604 3.23287 17.8023 3.63968L17.6971 4.37626L20.2751 4.74459L20.3804 4.00801Z",
    fill: "#7341B5"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 4.83641,
    height: 1.11609,
    rx: 0.372031,
    transform: "matrix(-0.989947 -0.141435 -0.141435 0.989947 21.8533 1.58801)",
    fill: "#7341B5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.96631 3.52148C7.8273 3.52148 8.6381 3.68427 9.39697 4.01172C10.1539 4.33835 10.8135 4.78274 11.3745 5.34375C11.9354 5.90471 12.379 6.56445 12.7056 7.32129C13.0329 8.08002 13.1967 8.89017 13.1968 9.75098C13.1968 10.612 13.033 11.4227 12.7056 12.1816C12.3789 12.9385 11.9355 13.5982 11.3745 14.1592C10.8135 14.7202 10.1539 15.1636 9.39697 15.4902C8.63808 15.8177 7.82732 15.9814 6.96631 15.9814C6.1055 15.9814 5.29535 15.8176 4.53662 15.4902C3.77978 15.1637 3.12004 14.7201 2.55908 14.1592C1.99807 13.5982 1.55368 12.9386 1.22705 12.1816C0.899603 11.4228 0.736816 10.612 0.736816 9.75098C0.736847 8.89023 0.899753 8.07997 1.22705 7.32129C1.55368 6.56434 1.99807 5.90476 2.55908 5.34375C3.1201 4.78274 3.77967 4.33835 4.53662 4.01172C5.2953 3.68442 6.10557 3.52152 6.96631 3.52148ZM6.96631 4.94727C5.63392 4.94732 4.50226 5.41424 3.56592 6.35059C2.62957 7.28693 2.16265 8.41859 2.1626 9.75098C2.1626 11.0834 2.62968 12.215 3.56592 13.1514C4.50226 14.0877 5.63392 14.5556 6.96631 14.5557C8.29881 14.5557 9.4303 14.0878 10.3667 13.1514C11.3031 12.215 11.771 11.0835 11.771 9.75098C11.7709 8.41859 11.303 7.28693 10.3667 6.35059C9.43034 5.41435 8.29869 4.94727 6.96631 4.94727ZM7.6792 6.58594V9.46387L9.91846 11.7031L9.98877 11.7744L8.98975 12.7734L8.91846 12.7031L6.25342 10.0381V6.58594H7.6792Z",
    fill: "#7341B5",
    stroke: "#7341B5",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGasespera);
export default __webpack_public_path__ + "static/media/gasespera.cd3267733c20a98d334cf070e93baf82.svg";
export { ForwardRef as ReactComponent };